module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921021151_T.86557daa.jpg";